// extracted by mini-css-extract-plugin
module.exports = {"btnAccordion":"styles_btnAccordion___2yvX","textTitle":"styles_textTitle__i0NpI","iconArrow":"styles_iconArrow___C9uQ"};